import { createFileRoute } from '@tanstack/react-router';
import { AppearancePage } from '@/features/settings/ui/AppearancePage';

export const Route = createFileRoute('/_authenticated/settings/')({ component: AppearancePage });
